export const AUTH_START = 'AUTH_START';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';

export const DELETE_ACC = 'DELETE_ACC'
export const LOGOUT = 'LOGOUT'

export const SWITCH_SIGN = 'SWITCH_SIGN' 

export const SWITCH_EDIT = 'SWITCH_EDIT'
export const SWITCH_CREATE = 'SWITCH_CREATE'

export const POST_COMMENT = "POST_COMMENT"
export const POST_LIKE = "POST_LIKE"